import { Link, NextImage } from "@jog/react-components"

export const Logo = ({
    href = "/",
    ["aria-label"]: ariaLabel,
    ...imageProps
}: { href?: string } & Parameters<typeof NextImage>[0]) => (
    <h1 className="flex items-center justify-center">
        <Link href={href} aria-label={ariaLabel}>
            <NextImage blur={false} {...imageProps} className="h-auto w-auto max-w-[150px] lg:max-w-[200px]" />
        </Link>
    </h1>
)
